import { State } from '.';
import { CDCCVX } from '../../models/cdc-cvx';

export const selectors = {
    getCDCCVX: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<CDCCVX> => state.byId[id || ''],
    getCDCCVXIds: (
        state: State
    ): number[] => state.allIds
};
